import { type PropsWithChildren, type FunctionComponent } from 'react';
import { useIsLuxuryTheme, useIsLuxuryTypography } from '../../hooks/theme/theme.hooks';

export const StyleLoader: FunctionComponent<PropsWithChildren> = ({ children }) => {
	const luxuryEnabled = useIsLuxuryTheme();
	const typographyEnabled = useIsLuxuryTypography();
	let domainStyle = 'base';
	if (luxuryEnabled) {
		domainStyle = 'luxury';
	} else if (typographyEnabled) {
		domainStyle = 'typography';
	}

	return (
		<div data-testid="style-loader" data-theme={domainStyle}>
			{children}
		</div>
	);
};
